import {Component, Input, OnInit} from '@angular/core';
import {OrdineService} from "../../../services/ordine.service";

@Component({
   selector: 'app-popup-barcode',
   templateUrl: './popup-barcode.component.html',
   styleUrls: ['./popup-barcode.component.scss']
})
export class PopupBarcodeComponent implements OnInit {

   @Input() component;
   @Input() hasTotals;

   constructor(private ordineSrv: OrdineService) { }

   ngOnInit(): void {
   }

   clickRemoveQtaAndBarcode($event: any, itemSel: any) {
      this.ordineSrv.clickRemoveQtaAndBarcode($event, itemSel, this.hasTotals)
   }
}
